<template>
    <div class="core">
       <div class="layui-fluid">
            <pub-search
              :search-type="'add'"
              :tableObj="tableObj"
              :searchConfig="searchConfig"
              exportTemplate="签到签退表.xlsx"
              >
              <template>
                <button class="layui-btn" title="创建流程" @click="addbpm" v-if="this.security.hasAuth('bpm_addBpm')">
                  <i class="layui-icon">&#xe624;</i>
                  创建流程
                </button>
              </template>
            </pub-search>
            <layui-table
              ref="templateTable"
              table-name="YW_TEMPLATE"
              :default-condition="defaultQuery"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              @table-event-edit="edit($event)"
              @table-event-del="delRow($event)">
            >
              <div>
                  <!-- <div checkbox="true" align="center" fixed="left" width="60"></div> -->
                  <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                  <layui-tableconfig :config = "tableList"></layui-tableconfig>
                  <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                      <script type="text/html" v-pre>
                          {{#  if(d._mark.indexOf("bpm_edit") > -1){ }}
                            <a class=" layui-btn-xs" lay-event="edit">编辑</a>
                          {{#  } }}
                          {{#  if(d._mark.indexOf("bpm_del") > -1){ }}
                            <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
                          {{#  } }}
                      </script>
                  </div>
              </div>
          </layui-table>
        </div>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'Bpm_List',
  components: {

  },
  data () {
    return {
      bpmShow: false,
      defaultQuery: {'DELETED:0': 0},
      tableObj: {
          checkedRows: 0,
          queryObject: {},

          search: this.search,
          reset: this.reset,
          search: this.search,
          delCheckedRows: this.delCheckedRows
      },
      searchConfig: {
        basic: [
            { TYPE:'input', WIDTH:260, NAME: '工程流程名称:', FIELD: 'TEMPLATE_NAME:2', PLACEHOLDER: '请输入流程名'},
          ]
      },
        tableList:[
          { field: 'TEMPLATE_NAME', title: '工程流程名称'},
          { field: 'CREATE_USERID_DESC', title: '创建人', width:100 },
          { field: 'CREATE_TIME', title: '创建时间', width:160},
          { field: 'BZ', title: '备注' }
        ],
        formData: null
    }
  },
  mounted: function () {
      this.$bus.$on('templateLoad', () => {
        this.$refs.templateTable.load()
      })
  },
  methods: {
    addbpm () {
      this.$bus.$emit('showBpm', 'add', { bpmId: '' })

      // this.$bus.$on('templateLoad', () => {
      //   this.$refs.templateTable.load()
      // })
    },
    edit($event){
      let data = $event.data
      this.$bus.$emit('showBpm', 'edit', {
        bpmId: data.TEMPLATE_ID,
        tplName: data.TEMPLATE_NAME,
        tplBZ: data.BZ,
        tplNode: data.TEMPLATE_NODE,
        tplDragNode: data.DRAGTEMPLATE_NODE ? data.DRAGTEMPLATE_NODE : {}
      })
    },
    delRow($event) {
      this.$refs.templateTable.delRows($event.data, { isLogic: true, reqId: 'delFlowTpl' })
    },
    search: function () {
      let refTable = this.$refs['templateTable']
      refTable.queryObject = this.tableObj.queryObject
      refTable.load()
    },
    reset: function () {
      let refTable = this.$refs['templateTable']
      this.tableObj.queryObject = {}
      refTable.queryObject = {}
      refTable.load()
    },
    delCheckedRows: function() {
      let refTable = this.$refs['templateTable']
      refTable.delCheckedRows({ isLogic: true, reqId: 'delFlowTpl'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/newBpm/index.vue